
import React from 'react';
// Ícones do Lucide React substituindo 'react-icons/fa' para evitar erro de resolução de módulo.
import { FaRegClock } from 'react-icons/fa';
import { IoIosGlobe } from "react-icons/io";
import { IoIosHelpCircleOutline } from "react-icons/io";
import foto1 from '../../images/FOTOS_CASA_ONDINA.jpg'
import foto2 from '../../images/corrente_bem.jpg'

// Componente para o bloco de informações de Horários
// O nome da propriedade 'icon' foi mantido para que a estrutura interna não precisasse ser alterada.
const ScheduleItem = ({ icon: Icon, title, description }) => (
  <div className="flex items-start space-x-4 mb-4">
    <Icon className="text-third w-6 h-6 mt-1 flex-shrink-0" />
    <div>
      <h3 className="text-lg font-semibold text-second">{title}</h3>
      <p className="text-gray-600 text-sm">{description}</p>
    </div>
  </div>
);

function corrente(){

  return (
    <div className="min-h-screen lg:pt-20 bg-gray-50 font-rubik">
      
      {/* Seção 1: Cabeçalho e Introdução Principal */}
      <header className="bg-primary pt-10 pb-16 px-4 md:px-8">
        <div className="max-w-7xl mx-auto">
          
          {/* Título e Descrição */}
          <div className="lg:flex lg:space-x-12 items-center">
            <div className="lg:w-1/2">
              <h1 className="text-4xl md:text-5xl font-rubik font-extrabold text-white mb-4 leading-tight">
                Corrente do Bem
              </h1>
              <p className="text-xl text-gray-100 mb-8">
                Leve amor e carinho através das palavras, escrevendo cartas para idosos em qualquer lugar do mundo. Junte-se a nós!
              </p>
            </div>
            
            {/* Imagem do Cabeçalho */}
            <div className="lg:w-1/2 rounded-xl overflow-hidden shadow-2xl">
              <img
                src={foto1}
                alt="Envelopes e cartas organizadas, simbolizando o Corrente do Bem"
                className="w-full h-auto object-cover"
                onError={(e) => { e.target.onerror = null; e.target.src='https://placehold.co/600x400/003087/ffffff?text=Imagem+N%C3%A3o+Carregada' }}
              />
            </div>
          </div>
        </div>
      </header>
      
      {/* Seção 2: Detalhes do Projeto e Chamada */}
      <section className="py-16 px-4 md:px-8 max-w-7xl mx-auto">
        <div className="mb-12">
          <p className="text-gray-700 leading-relaxed mb-6">
            A Associação Keralty Brasil é uma associação que cuida de pessoas em situação de cuidados paliativos com doenças crônicas incuráveis. Convidamos você a juntar-se nessa corrente de bem e apoiar os nossos pacientes idosos!
          </p>
          <p className="text-gray-700 leading-relaxed mb-6">
            Você pode oferecer o seu apoio neste momento atípico, escrevendo cartas motivacionais para um idoso, você será um verdadeiro anjo da guarda.
          </p>
          <p className="text-gray-700 leading-relaxed border-l-4 border-third pl-4 py-2 bg-third/10 rounded-r-lg">
            Funciona da seguinte maneira: Após se inscrever aqui na plataforma Atados, nossa equipe confirmará seu cadastro e entrará em contato por e-mail. Feito o contato inicial de boas vindas, enviaremos a você o nome do idoso que está aguardando a sua cartinha. Seja o anjo da guarda dele!!!
          </p>
        </div>

        {/* Seção 3: Imagem e Horários */}
        <div className="grid md:grid-cols-2 gap-12 items-center mt-16">
          
          {/* Imagem Secundária */}
          <div className="rounded-xl overflow-hidden shadow-2xl">
            <img
              src={foto2}
              alt="Mãos segurando uma carta com um tabuleiro de xadrez em foco, simbolizando atenção e cuidado"
              className="w-full h-auto object-cover"
              onError={(e) => { e.target.onerror = null; e.target.src='https://placehold.co/600x400/0072CE/ffffff?text=Imagem+N%C3%A3o+Carregada' }}
            />
          </div>

          {/* Horários */}
          <div className="bg-white p-8 rounded-xl shadow-lg border-t-4 border-primary">
            <h2 className="text-3xl font-bold text-primary mb-6">
              Horários
            </h2>
            <p className="text-gray-600 mb-8">
              Leia abaixo as descrições de horários para atuar nessa vaga.
            </p>
            
            {/* Itens de Horário */}
            <ScheduleItem
              icon={FaRegClock} // Substituído FaClock por Clock
              title="Flexível"
              description="Você define a melhor hora para escrever e enviar a sua carta."
            />
            <ScheduleItem
              icon={IoIosHelpCircleOutline} // Substituído FaQuestionCircle por HelpCircle
              title="O quanto for preciso"
              description="A dedicação e o carinho são o que contam. Não há um tempo mínimo exigido."
            />
            <ScheduleItem
              icon={IoIosGlobe} // Substituído FaGlobeAmericas por Globe
              title="À distância"
              description="Toda a ação é feita de forma remota, através de e-mail e correio."
            />
          </div>
        </div>
      </section>

      {/* Seção 4: Instruções de Envio e Nota */}
      <section className="py-16 px-4 md:px-8 max-w-7xl mx-auto">
        <div className="bg-primary/5 p-8 rounded-xl border-t-4 border-fourth">
          <p className="text-gray-700 leading-relaxed mb-4">
            Envie uma carta de próprio punho, com letra legível, contando um pouco sobre quem é você e diga algo que vai tocar o coração do idoso com muito carinho e afeto.
          </p>
          <p className="text-gray-700 leading-relaxed mb-6">
            Após escrever sua cartinha, você enviará ela, digitalizada, para o e-mail: <a href="mailto:associacao@keralty.com" className="text-fourth hover:underline font-semibold">associacao@keralty.com</a>. Atenção! Após se inscrever, pedimos gentilmente que aguarde a confirmação da inscrição e o recebimento das orientações da Associação Kerailty que serão encaminhadas via e-mail.
          </p>
          <p className="text-sm text-red-700 font-medium mt-6 p-3 bg-red-100 rounded-lg">
            OBS: Confira sempre sua caixa de entrada e de spam, para que não perca nossas orientações! Gostou da ideia e quer participar? Não perca tempo, inscreva-se e seja a ALEGRIA de alguém!
          </p>
        </div>
      </section>
      
      {/* Footer simples para fechar */}
      <footer className="bg-second py-4 text-center text-white text-sm">
        <p>Associação Kerailty Brasil | Corrente do Bem © 2025</p>
      </footer>
    </div>
  );
};

export default corrente;